import { parseEther } from '@ethersproject/units';
import { useWeb3React } from '@web3-react/core';
import { BigNumber } from 'ethers';
import useSWR from 'swr';
import abis from '../../config/abis';
import { fetcher } from '../../web3/utils';

const TWENTY_SECONDS_MS = 20000;

const useUserBalance = (tokenAddress: string | undefined) => {
    const { account, library } = useWeb3React();

    const { data: balance } = useSWR<BigNumber>(
        [tokenAddress ?? '', 'balanceOf', account],
        {
            fetcher: fetcher(library, abis.erc20),
            fallbackData: parseEther('0'),
            refreshInterval: TWENTY_SECONDS_MS,
            dedupingInterval: TWENTY_SECONDS_MS,
        }
    );

    return balance;
};

export default useUserBalance;
